import {
  FilteredItem,
  FilteredItemProps,
} from '@delmonicos/shared-design-system-react/src/components/filtered-item/filtered-item';
import { RfidBadgeOrderStatus } from '@delmonicos/shared-sdk/libs/cpms/src/libs/user-service-lib/src/wrapper/enums/rfid-badge-order-status.enum';
import { useTranslation } from 'react-i18next';

export interface EmspBoRfidBadgeOrderStatusFilterStateControllerProps {
  value: RfidBadgeOrderStatus;
  onRemove: FilteredItemProps['onRemove'];
}

export const EmspBoRfidBadgeOrderStatusFilterStateController = ({
  value,
  onRemove,
}: EmspBoRfidBadgeOrderStatusFilterStateControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // DATA FETCHING /////////////////////////////////////////////////////////////

  // Nothing to do

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <FilteredItem
      icon="credit-card-refresh"
      label={t(`delmonicos-shared-sdk.enums-rfid-badge-order-status.${value}`)}
      onRemove={onRemove}
    />
  );
};
